import { useState } from "react";
import Avatars from "./../../../assets/images/avatars.png";
import JamesLogo from "./../../../assets/images/james-logo2.png";
import { Link } from "react-router-dom";
import classNames from "classnames";
import { BiErrorCircle } from "react-icons/bi";

import { useMutation } from "react-query";
import { verifyAccount } from "../../../api/user";
import { showErrorToast } from "../../../utils/toast";

const pointer = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="335"
    height="102"
    viewBox="0 0 335 102"
    fill="none"
  >
    <path
      d="M332.729 3.61423C332.727 3.66323 332.724 3.71221 332.719 3.76297C332.637 4.55058 332.104 5.20344 331.592 5.80552C318.782 20.9083 303.385 38.1656 288.239 50.9002C242.42 89.4299 178.463 107.282 119.338 98.4418C98.6942 95.3544 78.5245 88.7228 60.1473 78.7657C51.2113 73.9246 42.4007 67.6167 34.4315 60.9028C26.6451 54.3412 18.3693 46.1046 10.4627 38.9339C10.2746 38.7641 9.96277 38.9304 9.92793 39.1825C9.52729 42.1264 5.6864 54.98 5.30144 55.9217C3.57346 60.1537 -0.269221 59.6409 0.45019 54.6318C1.29676 48.7387 2.55619 43.9781 3.96017 38.2741C4.43049 36.3594 5.01053 32.2008 6.46677 30.8776C8.19126 29.3112 10.7205 29.6944 13.046 29.6192C18.2839 29.4459 24.2169 28.9383 29.4722 29.4617C34.3165 29.9447 38.9448 34.6214 30.979 34.8121C25.7672 34.9364 19.944 35.0607 14.6903 34.8909C14.4987 34.8839 14.4029 35.1167 14.5457 35.2444C17.7108 38.0763 22.9993 43.4705 25.5372 46.2219C65.5421 89.5979 139.002 103.222 196.057 90.0757C207.226 87.5029 218.202 84.0759 228.85 79.8229C267.686 64.3105 302.277 32.57 325.237 4.97762C326.359 3.62994 327.315 1.97601 328.974 1.42293C330.585 0.885611 332.771 1.95151 332.729 3.61423Z"
      fill="#00EFC1"
    />
  </svg>
);

export default function VerifyAccount() {
  const [signupErrors, setSignupErrors] = useState([]);

  const mutation = useMutation(verifyAccount, {
    onSuccess: () => {
      window.location = window.location.origin;
    },
    onError: (e) => showErrorToast(e.message),
  });

  const onSubmit = (e) => {
    e.preventDefault();
    
    let formData = new FormData(e.target);
    const otp = formData.get("otp");
    if (!otp) {
        setSignupErrors("Enter Verification Code!");
    }

    const data = {
        otp,
        phoneNumber: localStorage.getItem("user-ph")
    }
    
    mutation.mutate(data);
  };

  return (
    <div className=" w-full h-full">
      <div className="h-full flex w-full">
        <div className="sm:w-1/2 w-full flex flex-col items-center h-full">
          <div className="sm:w-1/2 w-full sm:p-0 p-3 h-full py-10 flex flex-col gap-6 relative overflow-y-auto">
            <Link to={"/"}>
              <img src={JamesLogo} className="w-1/2" alt="logo" />
            </Link>
            <div className={classNames("space-y-3")}>
              <div className="font-bold text-[#101828] text-[34px]">
                Verify Account
              </div>
              <div className="text-[#667085] text-[16px]">
                Verify your Jamestown account
              </div>
            </div>
            <div className="w-full flex flex-col items-center">
              <div
                className={classNames(
                  "w-full p-3 bg-[#ff4c4c] mb-3 rounded-lg flex text-white gap-3",
                  {
                    hidden: signupErrors.length === 0,
                  }
                )}
              >
                <div className="text-[20px]">
                  <BiErrorCircle />
                </div>
                <div className="space-y-1 text-[14px] font-dmsans font-medium text-start">
                  {signupErrors.map((error, index) => {
                    return <div key={index}>{error}</div>;
                  })}
                </div>
              </div>

              <form className="w-full" onSubmit={onSubmit}>
                <div
                  className={classNames("flex flex-col gap-6 w-full")}
                >
                  <div className="flex gap-5">
                    <div className="">
                      <div className="text-[#344054] text-[14px] font-medium">
                        Verification Code
                      </div>
                    </div>
                  </div>
                </div>

                <div className="w-full">
                        <input
                          type="text"
                          name="otp"
                          className="w-full border-none bg-[#EFF0F6] p-3 rounded-[5px] text-[13px] "
                          placeholder="Verification Code"
                          required
                          maxLength={6}
                        />
                      </div>

                <div className="mt-4 w-full flex">
                  <button
                  disabled={mutation.isLoading}
                    type="submit"
                    className={`w-full mx-auto  bg-[#00EFC1] border-none rounded-3xl font-dmsans font-bold text-[15px] text-dark py-3 ${mutation.isLoading ? "animate-pulse" : ''}`}
                  >
                    {mutation.isLoading ? "Verifying..." : "Verify Account"}
                  </button>
                </div>
              </form>
              
            </div>
          </div>
        </div>
        <div className="hidden w-1/2 fixed right-0 p-20 bg-dark h-full sm:flex sm:flex-col items-center justify-center">
          <div className="flex flex-col gap-4">
            <div className="mt-5 relative flex flex-col items-center justify-center">
              <div className="text-left">
                <div className=" font-dmsans font-medium md:text-[64px]">
                  <div className="text-white leading-[77.4px]">
                    Do a lot with one{" "}
                    <span className="text-jgreen font-Manrope font-bold">
                      Application
                    </span>
                  </div>
                </div>
                <div className="py-4">
                  <div className="text-white text-sm font-medium font-inter leading-7">
                    Create a free account and get full access to all features .
                  </div>
                </div>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <img src={Avatars} className="w-[120px]" aria-label="icon" />
              <div className="text-[#E4E7EC] font-inter text-[16px] font-medium">
                Join x+ users
              </div>
            </div>
            <div
              className={classNames("relative z-10")}
            >
              <div className="absolute left-[-45%]">{pointer}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
